import { useEffect, useState } from 'react';
import { API_BASE } from '../services/api';

/**
 * Liest /files/:id/preview mit Credentials und liefert eine Blob-URL.
 * Zuverlässiger als rohes <img src>, weil Session-Cookies wie bei API-Requests mitgehen.
 */
export function useAuthenticatedFilePreview(fileId: number | null | undefined): string | undefined {
  const [blobUrl, setBlobUrl] = useState<string | undefined>();

  useEffect(() => {
    if (fileId == null) {
      setBlobUrl(undefined);
      return;
    }

    let alive = true;
    let objectUrl: string | null = null;

    const load = async () => {
      try {
        const res = await fetch(`${API_BASE}/files/${fileId}/preview`, {
          credentials: 'include',
        });
        if (!alive || !res.ok) return;
        const blob = await res.blob();
        if (!alive) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      } catch {
        if (alive) setBlobUrl(undefined);
      }
    };
    void load();

    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setBlobUrl(undefined);
    };
  }, [fileId]);

  return blobUrl;
}
